import { setLocationOnServerSession } from "../../components/DeliveryLocation/locationRepo";
import {
  getDeliveryAddressInfo,
  getLocationSelection,
  MarketplaceDeliveryLocation,
  saveLocationSelection,
} from "../../components/DeliveryLocation/user-settings";

/**
 * Checks server and client location selections, merges them, then returns the merged value.
 * @returns int
 */
export const mergeLocationSelections = async () => {
  const settings = getCurrentLocationSettings();

  // adjust location selection on both to match
  if (
    !settings.serverLocation.LocationId &&
    !settings.serverLocation.PostalCode
  ) {
    // no server location, set location
    if (settings.clientLocation) {
      await setLocationOnServerSession(settings.clientLocation); // save to session
    }
  } else {
    // we have server location

    if (settings.serverLocation.LocationId) {
      saveLocationSelection(settings.serverLocation.LocationId);
      settings.clientLocation = settings.serverLocation.LocationId;
    }
  }

  return {
    locationId: settings.clientLocation,
    redirectUrl: settings.serverLocation.RedirectUrl,
  };
};

interface LocationSettings {
  clientLocation: number | null;
  serverLocation: MarketplaceDeliveryLocation;
}

export const getCurrentLocationSettings = (): LocationSettings => {
  // check if location is selected on server
  const serverLocation = getDeliveryAddressInfo(false);

  // check if location is selected on client

  const clientLocation = getLocationSelection();

  return {
    clientLocation: clientLocation,
    serverLocation: serverLocation,
  };
};

interface LocationUpdateResult {
  LocationId: number | null;
  ServerWasUpdated: boolean;
}

const storeNumberSelected = (locationId?: number | null) => {
  if (locationId && locationId > 0) {
    return true;
  }
  return false;
};

const hasLocationSelected = (location: IDeliveryAddress) => {
  if (storeNumberSelected(location.LocationId)) {
    return true;
  }
  if (location.PostalCode) {
    return true;
  }

  return false;
};

/**
 * Compares session state location with client side location.  If session state = nothing and client side location exists, then persist
 * @returns
 */
export const TryPersistMarketplaceLocation =
  async (): Promise<LocationUpdateResult> => {
    const settings = getCurrentLocationSettings();
    const result: LocationUpdateResult = {
      LocationId: settings.clientLocation,
      ServerWasUpdated: false,
    };

    // adjust location selection on both to match
    if (!hasLocationSelected(settings.serverLocation)) {
      if (storeNumberSelected(settings.clientLocation)) {
        await setLocationOnServerSession(settings.clientLocation); // save to session
        result.ServerWasUpdated = true;
      }
    }

    return result;
  };

/**
 * Sets the location both server and client side
 * @param locationId
 */
export const saveLocationSelectionGlobal = async (locationId: number) => {
  saveLocationSelection(locationId);
  await setLocationOnServerSession(locationId);
};
